export enum accountFilterStatuses {
  recentlyCreated = "Recently created",
  fullName = "Full name",
  country = "Country"
}
